const GeoLocationActivity = () =>
  import(
    /* webpackChunkName: "location-location-activity" */ '@/pages/location/activity.vue'
  )

export default {
  path: 'activity',
  meta: {
    label: 'driverActivity',
    auth: 'activity'
  },
  component: {
    name: 'Activity',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'GeoLocatioActivityReport',
      path: '',
      meta: {
        label: 'report',
        auth: true
      },
      component: GeoLocationActivity
    }
  ]
}
